import { Spinner } from '@optools/components/loading/spinner';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@optools/components/ui/table';
import { PipelineInputConfigInfo } from '@optools/services/operator-gateway/types/generated/graphql';

import { PipelineInputConfigDialog } from './pipeline-input-config-dialog';

export interface PipelineInputConfigTableProps {
  configs: PipelineInputConfigInfo[] | undefined;
  loading: boolean;
}

export function PipelineInputConfigTable({
  configs,
  loading = true,
}: PipelineInputConfigTableProps) {
  return (
    <section>
      <h2 className="mb-4 text-xl font-bold" id="pipeline-input-configs-table-label">
        Input Configs
      </h2>
      {loading ? (
        <div className="flex h-52 items-center justify-center">
          <Spinner />
        </div>
      ) : configs && configs?.length > 0 ? (
        <Table
          aria-labelledby="pipeline-input-configs-table-label"
          className="whitespace-nowrap"
          data-testid="pipeline-input-config-table">
          <TableHeader>
            <TableRow>
              <TableHead>ID</TableHead>
              <TableHead>Feed Type Code</TableHead>
              <TableHead>Input Label</TableHead>
              <TableHead>Category</TableHead>
              <TableHead className="sr-only">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {configs.map((config) => {
              const { category, feedTypeCode, id, inputLabel } = config;
              return (
                <TableRow key={id}>
                  <TableCell>{id}</TableCell>
                  <TableCell>{feedTypeCode}</TableCell>
                  <TableCell>{inputLabel}</TableCell>
                  <TableCell>{category}</TableCell>
                  <TableCell>
                    <PipelineInputConfigDialog config={config} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <p>There are no input configs for this venue.</p>
      )}
    </section>
  );
}
